var _OPEN_GRAPH_IMAGE, _BRANDS$TAJAWAL, _BRANDS$ALMOSAFER, _VAT_COUNTRIES_MAP, _almosafer, _tajawal;
export var ERRORS = {
  ERROR_CODES: 'errorCodes',
  DEFAULT_ERROR_CODE: 'Something went wrong please try again',
  ON_LOAD_ERROR: 'errors_onload',
  RESPONSE_STATUS_TYPE_REF: 'https://www.w3.org/Protocols/rfc2616/rfc2616-sec10.html'
};
export var API_STATE = {
  INITIAL: 'INITIAL',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};

// production
export var GOOGLE_MAPS_KEY = 'AIzaSyCwZP4dtT6dxOEzD8nI3jEDFs1ZtXC3BMA';
// development
// export const GOOGLE_MAPS_KEY = `AIzaSyDck5G1hxI3qunAyPA0U_OxEJNPhyFiZzE`;

export var POLLING_STATE = {
  POLLING_START: 'POLLING_START',
  POLLING_RETRY: 'POLLING_RETRY',
  POLLING_IN_PROGRESS: 'POLLING_IN_PROGRESS',
  POLLING_FAILED: 'POLLING_FAILED',
  POLLING_END: 'POLLING_END'
};
export var SENTRY = {
  DSN: {
    DESKTOP: 'https://ccfd7a6eb88745c098eb8997b8847e8c@sentry.io/1407024',
    MWEB: 'https://507b0e54bef44ae3810a13231a359810@sentry.io/1445426',
    HOME: 'https://2ff2de4309df431d826f92213fd06fc0@sentry.io/1446253',
    FLIGHTS: 'https://3ebc3a8be84e49489a46e0a0faf2004c@sentry.io/1446263',
    HOTELS: 'https://e90c6d297f7c40fab647ca28dd6a5fb4@sentry.io/1515842',
    PAYMENT: 'https://3b6ef80134df4e38882690e39509f45f@sentry.io/1446265'
  },
  VERTICAL: {
    HOME: 'HOME',
    FLIGHTS: 'FLIGHTS',
    HOTELS: 'HOTELS',
    PAYMENT: 'PAYMENT',
    MWEB: 'MWEB'
  },
  TAGS: {
    API_ERROR: 'API_ERROR',
    REACTION: 'REACTION',
    UI_ERROR: 'UI_ERROR'
  }
};
export var ENDPOINTS = {
  CURRENCY_LIST: '/api/system/currency/list',
  COUNTRY_LIST: '/api/system/country/list',
  INSURANCE_PLANS: '/api/insurance/plan',
  APPLY_INSURANCE: '/api/insurance/cart',
  REMOVE_INSURANCE_PLAN: '/api/insurance/cart/{cartId}/product/{productId}',
  TOKEN_VISA_URL: '/api/payment-api/card/visa-checkout',
  CHECK_PAYMENT_3D_SECURE: '/api/check-payment-3ds?_c={pollingCount}&_t={pollingStartTime}',
  CMS_PAGE: '/api/cms/page',
  CMS_PAGE_NO_CACHE: '/api/cms/page?no-cache=true',
  SUB_NEWSLETTER: '/api/account/newsletter/subscribe',
  GOOGLE_TRANSLATION: '/api/hotel/ahs/cancellation-policy/translateRemarks',
  SALE: {
    GET_SALE: '/api/checkout/sale/{saleId}',
    GET_SALE_BY_NUMBER: '/api/checkout/sale/number?number={number}&id={id}',
    CALCULATE_REWARD: '/api/checkout/sale/{saleId}/calculate-reward'
  },
  CHECKOUT: {
    GET_CART: '/api/checkout/cart/{cartId}',
    GET_ORDER: '/api/checkout/order?orderNumber={orderNumber}',
    CREATE_CART: '/api/checkout/cart',
    CHECKOUT: '/api/checkout/cart/{cartId}/checkout',
    REFRESH_CART: '/api/checkout/cart/{cartId}/refresh',
    LOYALTY_REDEEM: '/api/checkout/cart/{cartId}/redeem',
    APPLY_COUPON: '/api/checkout/cart/{cartId}/coupon/{couponCode}',
    REMOVE_COUPON: '/api/checkout/cart/{cartId}/coupon',
    GET_INSTALLMENTS: '/api/checkout/cart/{cartId}/installment/plans?bin={binNumber}',
    // apple pay
    // GENERATE_TOKEN: '/api/checkout/cart/{cartId}/card/token',
    INIT_REDEEM: '/api/checkout/cart/{cartId}/init-redeem',
    PAYLATER_CHECKOUT: 'api/checkout/order/{orderNumber}/pay' // card, installments, banktransfer
  },
  CALCULATE_REWARD: '/api/loyalty/calculate-reward',
  CALCULATE_REWARD_BULK: '/api/loyalty/bulk-calculate-reward',
  AD_SOLUTION: {
    FETCH_AD_PLACEMENTS: '/adserve/multi'
  },
  USER: {
    ME: '/api/myaccount/v3/user/me'
  }
};
export var EVENTS = {
  APP_ERROR: 'app-error',
  FLIGHT: 'event.flight',
  FLIGHT_NON_INTERACTIVE: 'event.noninteractive.flight',
  CONTENT_VIEW: 'content-view',
  HEADER: 'Header',
  FLIGHT_SEARCH: 'flight.search',
  FLIGHT_MODIFY_SEARCH: 'flight.modify-search',
  FLIGHT_SEARCH_DETAIL: 'flight.search-details',
  FLIGHT_RESULTS: 'flight.results',
  FLIGHT_SELECT: 'flight.select',
  FLIGHT_DETAILS: 'flight.details',
  FLIGHT_BOOKING: 'flight.booking',
  FLIGHT_SEARCH_TEALIUM: 'flight_search',
  FLIGHT_DETAILS_TEALIUM: 'flight_details',
  FLIGHT_PAX_TEALIUM: 'flight_travelers',
  FLIGHT_PAYMENT_METHOD_TEALIUM: 'flight_payment_method',
  FLIGHT_PAYMENT_TEALIUM: 'flight_payment',
  FLIGHT_CONFIRMATION_TEALIUM: 'flight_confirmation'
};
export var CURRENCY = {
  BASE_NAME: 'Saudi Riyal',
  BASE_PLURAL: 'Saudi Riyal',
  BASE_SYMBOL: 'SAR',
  DEFAULT_ROUNDING: 0,
  DEFAULT_DECIMAL_DIGITS: 2
};
export var STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
  CURRENCY_LIST: 'CURRENCY_LIST',
  CURRENCY: 'currency',
  LANGUAGE: 'language',
  COUNTRY_LIST: 'COUNTRY_LIST',
  CACHED_TRAVELLERS: 'CACHED_TRAVELLERS'
};
export var CONNECTION_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline'
};
export var BRANDS = {
  TAJAWAL: 'tajawal',
  ALMOSAFER: 'almosafer'
};
export var OPEN_GRAPH_IMAGE = (_OPEN_GRAPH_IMAGE = {}, _OPEN_GRAPH_IMAGE[BRANDS.TAJAWAL] = 'http://cms-seo-prod.s3.eu-west-1.amazonaws.com/tjwl/files/2019-04/hero_0.jpg', _OPEN_GRAPH_IMAGE[BRANDS.ALMOSAFER] = 'https://tjwlcdn.com/cms/rebranding/assets/alm-fb-logo-en.jpg', _OPEN_GRAPH_IMAGE);
export var BRANDS_PREFIX = {
  TAJAWAL: 'TJ',
  ALMOSAFER: 'AM'
};
export var ENV = {
  LOCAL: 'local',
  DEV: 'dev',
  LIVE: 'live',
  STAGING: 'staging'
};
export var LOCALES = {
  EN: 'en_us',
  AR: 'ar_sa'
};
export var LANGUAGE = {
  EN: 'en',
  AR: 'ar'
};
export var COUNTRY_CURRENCY_MAP = {
  EG: 'EGP',
  SA: 'SAR',
  AE: 'AED',
  KW: 'KWD',
  BH: 'BHD',
  US: 'USD'
};
export var DOMAINS = {
  TJ_LIVE_COM: 'liveCom',
  TJ_LIVE_SA: 'liveSa',
  TJ_DEV_SA: 'devSa',
  TJ_DEV_COM: 'devCom',
  TJ_LIVE_BH: 'liveBh',
  TJ_DEV_BH: 'devBh',
  TJ_LIVE_AE: 'liveAe',
  TJ_DEV_AE: 'devAe',
  TJ_LIVE_KW: 'liveComKw',
  TJ_DEV_KW: 'devComKw',
  AM_LIVE_COM: 'liveMoCom',
  AM_DEV_COM: 'devMoCom',
  AM_LIVE_AE: 'liveMoAe',
  AM_DEV_AE: 'devMoAe',
  AM_LIVE_KW: 'liveMoKw',
  AM_DEV_KW: 'devMoKw',
  AM_LIVE_BH: 'liveMoBh',
  AM_DEV_BH: 'devMoBh',
  AM_LIVE_OM: 'liveMoOM',
  AM_DEV_OM: 'devMoOM',
  AM_LIVE_QA: 'liveMoQA',
  AM_DEV_QA: 'devMoQA',
  AM_LIVE_EG: 'liveMoEG',
  AM_DEV_EG: 'devMoEG',
  AM_LIVE_JO: 'liveMoJO',
  AM_DEV_JO: 'devMoJO',
  AM_LIVE_Global: 'liveMoGlobal',
  AM_DEV_Global: 'devMoGlobal'
};
export var EMAILS = {
  TJ_SUPPORT: 'support@tajawal.com',
  AM_SUPPORT: 'support@almosafer.com',
  AM_FLIGHTS_SUPPORT: 'flightsupport@almosafer.com'
};
export var CREDIT_CARDS = {
  VISA: 'visa',
  MASTER_CARD: 'master-card',
  AMERICAN_EXPRESS: 'american-express',
  MADA: 'mada',
  QITAF: 'QITAF',
  KNET: 'KNET'
};
export var DATA_SOURCES = {
  CACHE: 'cache',
  NETWORK: 'network'
};
export var VAT_COUNTRIES = {
  UAE: 'UAE',
  SA: 'KSA'
};
export var COUNTRY_CODE = {
  KW: 'KW',
  BH: 'BH',
  OM: 'OM',
  QA: 'QA',
  AE: 'AE',
  SA: 'SA',
  JO: 'JO',
  EG: 'EG',
  GLOBAL: 'GLOBAL'
};
export var ALLOWED_CURRENCIES = ['SAR', 'AED', 'QAR', 'KWD', 'BHD', 'USD', 'EUR', 'GBP', 'EGP'];
export var COUNTRY_CODE_MAP = {
  KW: 'Kuwait',
  BH: 'Bahrain',
  AE: 'United Arab Emirates',
  SA: 'Saudi Arabia',
  GLOBAL: 'Global'
};
export var VAT_COUNTRIES_MAP = (_VAT_COUNTRIES_MAP = {}, _VAT_COUNTRIES_MAP[BRANDS.TAJAWAL] = (_BRANDS$TAJAWAL = {}, _BRANDS$TAJAWAL[COUNTRY_CODE.AE] = 'UAE', _BRANDS$TAJAWAL["default"] = 'UAE', _BRANDS$TAJAWAL), _VAT_COUNTRIES_MAP[BRANDS.ALMOSAFER] = (_BRANDS$ALMOSAFER = {}, _BRANDS$ALMOSAFER[COUNTRY_CODE.SA] = 'KSA', _BRANDS$ALMOSAFER[COUNTRY_CODE.AE] = 'UAE', _BRANDS$ALMOSAFER[COUNTRY_CODE.KW] = 'Kuwait', _BRANDS$ALMOSAFER["default"] = 'KSA', _BRANDS$ALMOSAFER), _VAT_COUNTRIES_MAP);
export var POSConfig = {
  almosafer: (_almosafer = {}, _almosafer[COUNTRY_CODE.KW] = {
    code: COUNTRY_CODE.KW,
    url: 'https://kw.almosafer.com',
    devUrl: 'https://next-dev-kw.almosafer.com',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.KW]
  }, _almosafer[COUNTRY_CODE.BH] = {
    code: COUNTRY_CODE.BH,
    url: 'https://bh.almosafer.com',
    devUrl: 'https://next-dev-bh.almosafer.com',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.BH]
  }, _almosafer[COUNTRY_CODE.OM] = {
    code: COUNTRY_CODE.OM,
    url: 'https://om.almosafer.com',
    devUrl: 'https://next-dev-om.almosafer.com',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.OM]
  }, _almosafer[COUNTRY_CODE.QA] = {
    code: COUNTRY_CODE.QA,
    url: 'https://qa.almosafer.com',
    devUrl: 'https://next-dev-qa.almosafer.com',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.QA]
  }, _almosafer[COUNTRY_CODE.AE] = {
    code: COUNTRY_CODE.AE,
    url: 'https://ae.almosafer.com',
    devUrl: 'https://next-dev-ae.almosafer.com',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.AE]
  }, _almosafer[COUNTRY_CODE.SA] = {
    code: COUNTRY_CODE.SA,
    url: 'https://sa.almosafer.com',
    devUrl: 'https://next-dev-sa.almosafer.com',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.SA]
  }, _almosafer[COUNTRY_CODE.JO] = {
    code: COUNTRY_CODE.JO,
    url: 'https://jo.almosafer.com',
    devUrl: 'https://next-dev-jo.almosafer.com',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.JO]
  }, _almosafer[COUNTRY_CODE.EG] = {
    code: COUNTRY_CODE.EG,
    url: 'https://eg.almosafer.com',
    devUrl: 'https://next-dev-eg.almosafer.com',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.EG]
  }, _almosafer[COUNTRY_CODE.GLOBAL] = {
    code: COUNTRY_CODE.GLOBAL,
    url: 'https://global.almosafer.com',
    devUrl: 'https://next-dev-global.almosafer.com',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.GLOBAL]
  }, _almosafer),
  // @ts-ignore
  tajawal: (_tajawal = {}, _tajawal[COUNTRY_CODE.KW] = {
    code: COUNTRY_CODE.KW,
    url: 'https://tajawal.com.kw',
    devUrl: 'https://next-dev.tajawal.com.kw',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.KW]
  }, _tajawal[COUNTRY_CODE.BH] = {
    code: COUNTRY_CODE.BH,
    url: 'https://tajawal.bh',
    devUrl: 'https://next-dev.tajawal.bh',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.BH]
  }, _tajawal[COUNTRY_CODE.AE] = {
    code: COUNTRY_CODE.AE,
    url: 'https://tajawal.ae',
    devUrl: 'https://next-dev.tajawal.ae',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.AE]
  }, _tajawal[COUNTRY_CODE.SA] = {
    code: COUNTRY_CODE.SA,
    url: 'https://tajawal.sa',
    devUrl: 'https://next-dev.tajawal.sa',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.SA]
  }, _tajawal[COUNTRY_CODE.GLOBAL] = {
    code: COUNTRY_CODE.GLOBAL,
    url: 'https://global.tajawal.com',
    devUrl: 'https://next-dev-global.tajawal.com',
    name: COUNTRY_CODE_MAP[COUNTRY_CODE.GLOBAL]
  }, _tajawal)
};
export var APP_ROUTES = {
  FLIGHTS_HOME: '/{language}/flights-home',
  FLIGHTS_RESULTS_V1: '/{language}/v1/flights/{query}',
  FLIGHTS_RESULTS: '/{language}/flights/{query}',
  FLIGHTS_PAX: '/{language}/flight/traveller/{cartId}',
  FLIGHTS_PAYMENT: '/{language}/flight/seat/{cartId}'
};
export var APP_PAGES = {
  HOME: 'HOME',
  FLIGHTS_HOME: 'FLIGHTS_HOME',
  FLIGHTS_RESULTS_V1: 'FLIGHTS_RESULTS_V1',
  FLIGHTS_RESULTS: 'FLIGHTS_RESULTS',
  FLIGHTS_PAX: 'FLIGHTS_PAX',
  FLIGHTS_EXTRAS: 'FLIGHTS_EXTRAS',
  FLIGHTS_PAYMENT: 'FLIGHTS_PAYMENT',
  FLIGHTS_CONFIRMATION: 'FLIGHTS_CONFIRMATION',
  FLIGHTS_MANAGE_BOOKING: 'FLIGHTS_MANAGE_BOOKING',
  HOTELS_HOME: 'HOTELS_HOME',
  HOTELS_RESULTS: 'HOTELS_RESULTS',
  HOTELS_DETAILS: 'HOTELS_DETAILS',
  HOTELS_GUEST: 'HOTELS_GUEST',
  HOTELS_PAYMENT: 'HOTELS_PAYMENT',
  HOTELS_CONFIRMATION: 'HOTELS_CONFIRMATION',
  HOTELS_MANAGE_BOOKING: 'HOTELS_MANAGE_BOOKING'
};
export var EMAIL_REGEX = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2,})\b$/;
export var SPECIAL_FORMAT_DIAL_CODES = ['+971', '+966'];
export var LOWEST_VALID_PHONE_NUMBER = 5;
export var VALID_NUMBER_WITHOUT_ZERO_IN_BEGINNING = 9;
export var VALID_NUMBER_WITH_ZERO_IN_BEGINNING = 10;
export var HOUR_MINUTES = 60;
export var SALES_FORCE = {
  DEV: {
    ENDPOINT: 'https://altayyargroup--UAT.cs89.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8',
    ORG_ID: '00D5E000000DXFS'
  },
  LIVE: {
    ENDPOINT: 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8',
    ORG_ID: '00D0N000001MRjh'
  }
};
export var CART_PRODUCT_TYPES = {
  VAT: 'vat',
  INSURANCE: 'insurance',
  OTHER: 'other',
  RULE: 'rule',
  COUPON: 'coupon',
  LOYALTY: 'loyalty',
  FLIGHT: 'flight',
  HOTEL: 'hotel',
  ACCOMMODATION: 'accommodation',
  QITAF: 'qitaf',
  WALLET: 'wallet',
  GIFTCARD: 'gift-card',
  ACTIVITIES: 'activity',
  MOKAFAA: 'mokafa',
  ORDER: 'order',
  CART: 'cart'
};
export var SALE_TYPE = {
  ORDER: 'order',
  CART: 'cart'
};
export var SALE_CART_TYPES = {
  FLIGHT: 'flight',
  HOTEL: 'hotel',
  ACCOMMODATION: 'accommodation',
  ACTIVITIES: 'activity',
  ADDON: 'addon'
};
export var ACTION_TYPES = {
  // CREATE_CART: 'CREATE_CART',
  FETCH_SALE: 'FETCH_SALE',
  FETCH_CART: 'FETCH_CART',
  QITAF_REDEEM: 'QITAF_REDEEM',
  MOKAFAA_REDEEM: 'MOKAFAA_REDEEM',
  WALLET_REDEEM: 'WALLET_REDEEM',
  APPLY_COUPON: 'APPLY_COUPON',
  REMOVE_COUPON: 'REMOVE_COUPON',
  FETCH_USER: 'FETCH_USER'
  // UPDATE_CART: 'UPDATE_CART',
  // UPDATE_FLIGHT_SSR: 'UPDATE_FLIGHT_SSR',
  // CHECKOUT_CART: 'CHECKOUT_CART',
  // INIT_REDEEM: 'INIT_REDEEM'
};
export var ACCOUNT_TYPE = {
  LOCAL: 'local',
  SOCIAL: 'social'
};
export var ACCOUNT_STATUS = {
  ACTIVE: 'active'
};
export var PAYMENT_METHODS = {
  CHECKOUTCOM: 'checkoutcom',
  PAYFORT: 'payfort',
  TAJAWAL_PAY: 'tp',
  PAY_LATER: 'op',
  INSTALLMENTS: 'installments',
  FORT: 'fort',
  KNET: 'knet',
  THREE_D_SECURE: '3dsecure',
  QITAF: 'qitaf',
  WALLET: 'wallet',
  APPLE_PAY: 'apple-pay'
};
export var LOYALTY_METHODS = {
  QITAF: 'qitaf',
  FURSAN: 'fursan',
  WALLET: 'wallet',
  MOKAFAA: 'mokafa',
  SHUKRAN: 'shukran'
};
export var HOSTS = {
  AD_SOLUTION: {
    DEV: 'https://servedbyadbutler.com',
    LIVE: 'https://servedbyadbutler.com',
    PATHNAME: '/adsolution'
  }
};
export var AD_SOLUTION_ACCOUNT = {
  LIVE: 186186,
  STAGING: 186627
};
export var VERTICALS = {
  FLIGHTS: 'FLIGHTS',
  HOTELS: 'HOTELS',
  ACTIVITIES: 'ACTIVITIES',
  PAYMENT: 'PAYMENT',
  HOME: 'HOME',
  MY_ACCOUNT: 'MY_ACCOUNT'
};
export var AD_PLACEMENT_PRODUCT_TYPE = {
  ACTIVITY: 'activity',
  FLIGHT: 'flight',
  HOTEL: 'hotel'
};